import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { BaseGroupType } from 'src/AngularJS/Models/group-type.model';
import { Group } from 'src/AngularJS/Models/group.model';
import { GroupSelectorService } from 'src/app/reusables/group-selector/group-selector.service';
import { ModuleManager } from 'src/shared/models/module-manager';
import { IModuleManagerToolbarComponent } from 'src/shared/models/module-manager/module-manager-toolbar-component.model';

@Component({
    selector: 'cv-cxone-teams',
    templateUrl: './cxone-teams.component.html',
    styleUrls: ['./cxone-teams.component.scss']
})
export class CxoneTeamsComponent implements IModuleManagerToolbarComponent, OnInit, OnDestroy {
    @Input() moduleManager: ModuleManager;
    @Input() context?: any;

    @ViewChild('pop') teamsPopover: NgbPopover;

    teams: Group[] = [];
    isHovering = 0;

    _settingsManagerSubscription: Subscription = null;
    _settingsAppliedSubscription: Subscription = null;

    constructor(
        private groupSelectorService: GroupSelectorService
    ) {

    }

    ngOnInit() {
        this._settingsManagerSubscription = this.moduleManager.slideoutSettingsManager.subscribe(settingsManager => {
            if (!settingsManager)
                return;

            if (this._settingsAppliedSubscription)
                this._settingsAppliedSubscription.unsubscribe();
            this._settingsAppliedSubscription = settingsManager.onSettingsApplied.subscribe(() => {
                this.loadTeams();
            });
        });

        this.loadTeams();
    }

    ngOnDestroy() {
        this._settingsAppliedSubscription?.unsubscribe();
        this._settingsManagerSubscription?.unsubscribe();
    }

    async loadTeams() {
        const response = await this.groupSelectorService.loadFilteredGroups(this.moduleManager.getModuleKey(), BaseGroupType.Employee, 2);
        const selectedTeams = new Set(this.moduleManager?.moduleSettings.empSelectorDTO?._SelectedGroup2IDList ?? []);
        const teams = response.data[2]?.Groups ?? [];
        if (selectedTeams.size > 0 && !selectedTeams.has(0))
            this.teams = teams.filter(t => selectedTeams.has(t.GroupID));
        else
            this.teams = teams;
    }

    addHover() {
        this.isHovering++;
        this.handleHover();
    }

    removeHover() {
        // give time to hover over the popover before dismissing it
        setTimeout(() =>  {
            this.isHovering--; 
            this.handleHover();
        }, 100);

    }

    handleHover() {
        if(this.isHovering) 
            this.teamsPopover.open();
        else
            this.teamsPopover.close();
    }
}
